// hooks/useDeleteSuppliers.ts
import { useState } from 'react';
import { supabase } from '../lib/supabase';
import { captureSupabaseError } from '../lib/sentry';

interface DeleteOptions {
  deleteContacts?: boolean;
}

export const useDeleteSuppliers = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const deleteSuppliers = async (
    supplierIds: string[],
    options: DeleteOptions = {}
  ) => {
    setLoading(true);
    setError(null);

    try {
      for (const id of supplierIds) {
        const { error } = await supabase.rpc('delete_supplier', {
          p_supplier_id: id,
          delete_contacts: options.deleteContacts ?? false,
        });

        if (error) {
          console.error('Error deleting supplier:', error);
          setError(error.message);
          setLoading(false);
          return false;
        }
      }

      setLoading(false);
      return true;
    } catch (err) {
      captureSupabaseError(err, { op: 'supplier.delete' });
      console.error('Unexpected error deleting suppliers:', err);
      setError((err as Error).message);
      setLoading(false);
      return false;
    }
  };

  return { deleteSuppliers, loading, error };
};
